import React from 'react';
import './DomainMonogram.css';
import { domainInitials, monogramToneIndex } from '../../utils/domainMonogram';

type MonogramSize = 'sm';

const SIZE_PX: Record<MonogramSize, number> = {
  sm: 20,
};

export interface DomainMonogramProps {
  /** Domain display name — drives the initials. */
  name: string;
  /** Stable seed (site_id) — drives the deterministic tone. */
  seed: string;
  /** Visual size; only 'sm' (20px) exists today, matching the 18–20px row height. */
  size?: MonogramSize;
}

/**
 * Rounded-square monogram tile shown before a domain name. Decorative only
 * (`aria-hidden`) — the surrounding row/button already carries the accessible
 * name. Colour is a deterministic muted tone keyed off `seed`.
 */
export const DomainMonogram: React.FC<DomainMonogramProps> = ({ name, seed, size = 'sm' }) => {
  const tone = monogramToneIndex(seed);
  const style = {
    '--monogram-size': `${SIZE_PX[size]}px`,
    background: `var(--color-monogram-${tone}-bg)`,
    color: `var(--color-monogram-${tone}-fg)`,
  } as React.CSSProperties;

  return (
    <span className="domain-monogram" aria-hidden="true" style={style}>
      {domainInitials(name)}
    </span>
  );
};

export default DomainMonogram;
